export const dashboardPathByRole = {
  admin: '/admin/dashboard',
  trainer: '/trainer/dashboard',
  learner: '/learner/dashboard'
};

export const roleOptions = ['learner', 'trainer', 'admin'];

export function normalizeUserRoles(user) {
  const assigned = Array.isArray(user?.roles) && user.roles.length ? user.roles : [user?.role || 'learner'];
  return roleOptions.filter((role) => assigned.includes(role));
}

export function activeUserRole(user) {
  const roles = normalizeUserRoles(user);
  return roles.includes(user?.role) ? user.role : roles[0] || 'learner';
}

export function defaultDashboard(role) {
  return dashboardPathByRole[role] || '/login';
}

export function canAccessRole(user, role) {
  if (!user) return false;
  return activeUserRole(user) === role && normalizeUserRoles(user).includes(role);
}

export function canSwitchToRole(user, role) {
  return normalizeUserRoles(user).includes(role);
}
